import { render, staticRenderFns } from "./SquareTopicView.vue?vue&type=template&id=3b235548&scoped=true"
import script from "./SquareTopicView.vue?vue&type=script&lang=js"
export * from "./SquareTopicView.vue?vue&type=script&lang=js"
import style0 from "./SquareTopicView.vue?vue&type=style&index=0&id=3b235548&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b235548",
  null
  
)

export default component.exports